import DeviceInfo from 'react-native-device-info';
import { AsyncStorage } from '../../storage';
import { OtaVersionService } from '../../services';
import { logError } from '../../logging';

export const getOtaVersion = () => {
  return AsyncStorage.getStorage().getString('OTA_VERSION');
};

export const sendOtaVersion = async () => {
  try {
    const otaVersion = getOtaVersion();

    if (!otaVersion) {
      console.warn('OTA version missing', otaVersion);
      return;
    }

    await OtaVersionService.sendVersion({
      headers: {
        'x-app-ota-version': otaVersion,
      },
    });
  } catch (error) {
    logError('Failed to send OTA version:', error);
  }
};

export const getAppVersion = () => {
  return DeviceInfo.getVersion();
};

export const getVersion = () => {
  const otaVersion = getOtaVersion();

  if (otaVersion) {
    return otaVersion;
  }

  return getAppVersion();
};

export const getFullVersion = () => {
  const otaVersion = getOtaVersion();
  const appVersion = DeviceInfo.getVersion();

  if (otaVersion) {
    return `${appVersion} (${otaVersion})`;
  }

  return appVersion;
};
